import { z } from 'zod';

export const invoiceRecipientValues = [
  'site',
  'provider',
  'patient',
  'wcb',
  'blueCross',
] as const;
export const invoiceRecipient = z.enum(invoiceRecipientValues);
export const invoiceRecipientEnum = invoiceRecipient.enum;

export const invoiceTypeValues = ['site', 'tariff'] as const;
export const invoiceType = z.enum(invoiceTypeValues);
export const invoiceTypeEnum = invoiceType.enum;

export const invoiceSchema = z.object({
  id: z.string(),
  file: z.string().optional().nullable(),
  recipient: invoiceRecipient.optional().nullable(),
  siteID: z.string().optional().nullable(),
  providerID: z.string().optional().nullable(),
  patientID: z.string().optional().nullable(),
  claimID: z.string().optional().nullable(),
  amount: z.string().optional().nullable(),
  invoiceNumber: z.number().optional().nullable(),
  date: z.string().optional().nullable(),
  type: invoiceType,
});

export type InvoiceRecipient = z.infer<typeof invoiceRecipient>;
export type InvoiceType = z.infer<typeof invoiceType>;
export type Invoice = z.infer<typeof invoiceSchema>;
